var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatIsAnHraCloud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 647,
    height: 470,
    viewBox: "0 0 647 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368.883 2.6554C483.423 17.1995 560.52 77.4074 579.249 174.901C583.395 196.484 594.864 216.11 609.64 232.38C635.542 260.902 649.827 299.267 646.107 340.034C638.932 418.676 567.472 476.475 486.498 469.13C461.87 466.896 439.199 458.893 419.774 446.624C387.328 457.738 351.927 462.365 315.369 459.049C282.177 456.038 251.109 446.758 223.29 432.525C196.786 457.593 159.596 471.623 119.842 468.017C47.515 461.457 -5.90515 399.013 0.524594 328.545C3.81676 292.464 26.2407 263.381 55.637 243.74C80.1221 227.38 100.283 203.545 107.469 174.987C134.945 65.7901 222.128 -15.9792 368.883 2.6554Z",
    fill: "#F6FAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatIsAnHraCloud);
export default __webpack_public_path__ + "static/media/whatIsAnHRACloud.5143170b112a9eb3a792d880e2a5ffba.svg";
export { ForwardRef as ReactComponent };